import React from "react";
import ProjectForm from "./ProjectForm";
import TeamForm from "./ProjectForm";

function ProjectModal({ open, handleModal, projectState }) {
  const modalRef = React.useRef(null);
  React.useEffect(() => {
    modalRef?.current?.classList.add("animate__zoomIn");
    modalRef?.current?.addEventListener("animationend", (event) => {
      modalRef?.current?.classList.remove("animate__zoomIn");
    });
  }, [open]);

  const handleClose = () => {
    modalRef?.current?.classList.add("animate__zoomOut");
    modalRef?.current?.addEventListener("animationend", (event) => {
      handleModal();
    });
  };

  return open ? (
    <div
      ref={modalRef}
      className={`fixed inset-0 z-10 flex flex-col items-center justify-start  animate__animated bg-black/10 backdrop-blur-sm`}
    >
      <button
        className="fixed right-6 top-4 text-2xl  text-violet-900"
        onClick={handleClose}
      >
        X
      </button>
      <ProjectForm
        handleModal={handleModal}
        modalRef={modalRef}
        projectState={projectState}
      />
    </div>
  ) : null;
}

export default ProjectModal;
